import { brandRedirectParts } from '~/lib/brand-redirect';
export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return; // HTTP middleware handles the initial request.
  const parts = brandRedirectParts(to.fullPath);
  if (!parts) return;
  const result = await $fetch<{ targetId: number | null }>('/api/brands/alias', { query: { id: parts.id } });
  if (result.targetId) return navigateTo(`/catalog/brands/${result.targetId}${parts.suffix}`, { replace: true, redirectCode: 301 });
});
